export enum HomeCategoryPromotionType {
  ONE_CIKAN_TUR_KATEGORILERI = 'one_cikan_tur_kategorileri',
  ONE_CIKAN_GEMI_KATEGORILERI = 'one_cikan_gemi_kategorileri',
  ONE_CIKAN_OTEL_KATEGORILERI = 'one_cikan_otel_kategorileri',
  ONE_CIKAN_YURT_DISI_OTEL_KATEGORILERI = 'one_cikan_yurt_disi_otel_kategorileri',
}
